<div class="header" *ngIf="currentProject">
  <div>{{ currentProject?.name }}</div>
  <div>phase {{ currentProject?.currentPhase?.phaseId }} dashboard</div>
</div>
<ul class="nav-list">
  <li *ngFor="let entry of entries" [navigationLink]="entry"></li>
</ul>
